import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-validation-failed-modal',
  standalone: true,
  imports: [],
  templateUrl: './validation-failed-modal.component.html',
  styleUrl: './validation-failed-modal.component.scss'
})
export class ValidationFailedModalComponent {
  
  constructor(public activeModal: NgbActiveModal) { }

}
